import { configureStore } from "@reduxjs/toolkit";

import reportingFilterReducer from "./reporting-filter.slice";
import dashboardFilterReducer from "./dashboard-filter.slice";
import { createDispatchHook, createSelectorHook } from "react-redux";
import { createContext } from 'react';

const store = configureStore({
  reducer: {
    reportingFilter: reportingFilterReducer,
    dashboardFilter: dashboardFilterReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: {
        ignoredPaths: ["ignoredPath", "ignoredNested.one", "ignoredNested.two"],
      },
    }),
}); 

export const adminStoreContext = createContext();

export const useAdminSelector = createSelectorHook(adminStoreContext);
export const useAdminDispatch = createDispatchHook(adminStoreContext);

export default store;
